import React, { useContext } from 'react';
import Skeleton from '../../Skeleton';
import { dataHooks, sidebarSkins } from '../constants';
import { st, classes } from './SidebarSkeleton.st.css.js';
import { SidebarNextContext } from '../SidebarNextContext';
/** SidebarSkeletonItem */
const SidebarSkeletonItem = ({ isLong = false }) => {
    return React.createElement("div", { className: st(classes.skeletonItem, { long: isLong }) });
};
/** SidebarSkeleton */
const SidebarSkeleton = () => {
    const { skin } = useContext(SidebarNextContext);
    return (React.createElement("div", { "data-hook": dataHooks.skeleton, className: classes.container }, skin === sidebarSkins.light ? (React.createElement("div", { className: classes.lightSkeleton },
        React.createElement(Skeleton, { spacing: "small", content: [
                { type: 'line', size: 'medium' },
                { type: 'line', size: 'large' },
            ] }),
        React.createElement(Skeleton, { spacing: "small", content: [
                { type: 'line', size: 'large' },
                { type: 'line', size: 'medium' },
                { type: 'line', size: 'large' },
                { type: 'line', size: 'medium' },
            ] }))) : (React.createElement("div", null,
        React.createElement(SidebarSkeletonItem, null),
        React.createElement(SidebarSkeletonItem, { isLong: true }),
        React.createElement(SidebarSkeletonItem, { isLong: true }),
        React.createElement("div", { className: classes.separator }),
        React.createElement(SidebarSkeletonItem, null),
        React.createElement(SidebarSkeletonItem, { isLong: true }),
        React.createElement(SidebarSkeletonItem, null)))));
};
SidebarSkeleton.displayName = 'SidebarSkeleton';
export default SidebarSkeleton;
//# sourceMappingURL=SidebarSkeleton.js.map